import React, { createContext, useContext, useState, useMemo, useEffect, useRef } from 'react';

const GlobalSearchContext = createContext();

export function GlobalSearchProvider({ children }) {
  const [searchTerm, setSearchTerm] = useState('');
  const lastPath = useRef(window.location.pathname);
  const value = useMemo(() => ({ searchTerm, setSearchTerm }), [searchTerm]);

  // Clear search when navigating to a different page
  useEffect(() => {
    const checkRoute = () => {
      if (window.location.pathname !== lastPath.current) {
        lastPath.current = window.location.pathname;
        setSearchTerm('');
      }
    };
    window.addEventListener('popstate', checkRoute);
    const orig = window.history.pushState;
    window.history.pushState = function() { orig.apply(this, arguments); checkRoute(); };
    const origReplace = window.history.replaceState;
    window.history.replaceState = function() { origReplace.apply(this, arguments); checkRoute(); };
    return () => {
      window.removeEventListener('popstate', checkRoute);
      window.history.pushState = orig;
      window.history.replaceState = origReplace;
    };
  }, []);

  return (
    <GlobalSearchContext.Provider value={value}>
      {children}
    </GlobalSearchContext.Provider>
  );
}

export function useGlobalSearch() {
  return useContext(GlobalSearchContext);
}
